<mat-toolbar>

    <div appFlexLayout="row" appFlexAlign="center center" Align.gt-xs="space-between center" appFlex>

        <span appFlex=""></span>

        <div appFlexLayout="row" appFlexAlign="start center" fxHide fxShow.gt-xs>
            <a mat-button href="https://www.inbe.ca" target="_blank">(c) inbe</a>
        </div>

    </div>

</mat-toolbar>